import React from "react";


const SortOverlay = (props) => {
  return (
    <div
      className="finderTable-sort-overlay"
      style={{ left: props?.overlayStyle?.left, top: props?.overlayStyle?.height}}
      onMouseLeave  ={props.closeOverlayDelay} onMouseEnter={props.keepOverlay}>
      <button data-sort="unsort" onClick={props.closeOverlay} className="finderTable-sort-overlay-btn">{window.finderTable.dict.sortUnsorted}</button>
      <button data-sort="asc" onClick={props.closeOverlay} className={`${props?.overlayStyle?.dir==="asc" ? 'active': ''} finderTable-sort-overlay-btn`}>{window.finderTable.dict.sortAscending}</button>
      <button data-sort="desc" onClick={props.closeOverlay} className={`${props?.overlayStyle?.dir==="desc" ? 'active': ''} finderTable-sort-overlay-btn`}>{window.finderTable.dict.sortDescending}</button>
    </div>
  );
};

export default SortOverlay;
